import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "./Reveal";

const FAQS = [
  ["What does Tilla' actually do?", "You record audio — a lecture, a meeting, a conversation. Tilla' turns it into organized notes, a short summary, and the tasks and reminders that came up, so you don't have to write anything afterwards."],
  ["How do the 5 free recordings work?", "Join the early-access list and your first 5 recordings are free. After that, Pro is €4.99 per month."],
  ["Can I cancel my subscription?", "Yes. The monthly subscription can be cancelled anytime."],
  ["When does Tilla' launch?", "We're putting the finishing touches on it. Everyone on the early-access list will get an email the moment it's ready."],
  ["Can I subscribe now?", "Yes — you can start your Pro subscription today from the pricing section, securely through Stripe."],
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="border-t border-white/5 py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-4">
        <SectionHead eyebrow="FAQ" title="Questions, answered." />
      </div>
      <Accordion type="single" collapsible className="lg:col-span-8">
        {FAQS.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg font-semibold hover:no-underline">{q}</AccordionTrigger>
            <AccordionContent className="text-base leading-relaxed text-muted-foreground">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
